import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent'
const LmDomainContext = () => {
    return (
        <>
            <div className='row pt-20 px-10 mb-20'>
                <div className='col-md-12 text-center'>
                    <SectionHeader_2
                        title= {`Domain & Context`}
                    />
                </div>
                <div className='row mt-20 border px-10 br-20'>
                    <div className='col-md-5 pe-15 m-auto'>
                        <img src="/assets/img/developer-guide.jpg" alt="app image" className="radius-20 p-10 ps-0" style={{}} />
                    </div>
                    <div className='col-md-7 m-auto'>
                        <div className='mt-6'>
                            <ul className="list-check ">
                                <li className='d-flex text-gray-700 fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    Small Language Models (SLMs) or Domain Specific Language Models (DLMs) are reliable for end-use applications, as they work within the required context. Whereas LLMs are more effective as productivity boosters.
                                </li>
                                <li className='d-flex text-gray-700 fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    We build these SLMs/DLMs in a jiffy, as compared with the long road for building LLMs.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {LmDomainContext}